<template>
  <b-row class="margin-0">
    <b-col cols="12" class="padding-0 height--max-content">
      <ListWrapper
        ref="listWrapperReference"
        :url="url"
        :title="$lang.centerExecuteRooms"
        :isUseInSidebar="true"
        :hasAddButton="false"
        :addButtonText="$lang.newPerson"
        menuBarClass="padding-x-16"
        searchTxtClass="width-percent-100"
        wrapperClass="background-surface border-radius-8 border--solid border--complementary-50 padding-y-16"
        wrapperListContentClass="height--100vh--240"
        titleClass="padding-x-16"
        @getPermissions="getPermissions"
      >
        <template slot-scope="{ items, itemsLoading }">
          <LoadingWrapper :loading="itemsLoading">
            <template #loading>
              <ListLoading :count="5" />
            </template>
            <template #default>
              <b-row class="margin-0 padding-x-16">
                <b-col
                  cols="12"
                  v-for="(item, index) in generateItems(items)"
                  :key="`room-${index}`"
                  class="border--solid border--complementary-50 border-radius-8 margin-bottom-8 padding-16"
                >
                  <RoomItem :item="item" />
                </b-col>
              </b-row>
            </template>
          </LoadingWrapper>
        </template>
      </ListWrapper>
    </b-col>
  </b-row>
</template>

<script>
import { ListWrapper, LoadingWrapper } from "@/components/re-design";
import ListLoading from "./ListLoading.vue";
import RoomItem from "./RoomItem.vue";
import { pathOr } from "ramda";
import { computed, inject, provide, ref } from "vue";
import { generateApiUrl } from "@/shared/utils";
export default {
  components: {
    ListWrapper,
    LoadingWrapper,
    ListLoading,
    RoomItem,
  },
  setup() {
    const centerExecuteData = inject("CENTER_EXECUTE_DATA");

    const centerExecuteId = pathOr(null, ["id"], centerExecuteData.value);
    const url = generateApiUrl(
      ["kanoon", "centerExecuteRooms"],
      [centerExecuteId]
    );

    // handle permissions
    const permissions = ref([]);
    const getPermissions = (data) => (permissions.value = data);

    // generate list
    const generateItems = (items) => {
      return items.map((item) => {
        return {
          id: pathOr("", ["id"], item),
          name: pathOr("", ["name"], item),
          roomNumber: pathOr("", ["room_number"], item),
          link: pathOr("", ["link"], item),
          capacity: pathOr(null, ["capacity"], item),
        };
      });
    };

    // handle reload list
    const listWrapperReference = ref(null);
    const handleReloadList = () => listWrapperReference.value.reload();

    // provide data
    provide(
      "PERMISSIONS",
      computed(() => permissions.value)
    );
    provide("handleReloadList", handleReloadList);

    // return data to be used in template
    return {
      url,
      getPermissions,
      generateItems,
      listWrapperReference,
    };
  },
};
</script>
